import { LOGO_PATH } from '@/config/gbwaps';

/** 首页配图（本地化） */
const IMG = '/images/gbwaps/home';

export const HOME_IMAGES = {
	/** 全站统一 GB 圆角 Logo */
	siteLogo: LOGO_PATH,
	/** 首页 / 内页横幅（GBWaps 专属 PNG，无竞品域名） */
	downloadCard: `${IMG}/download-apk-card.png`,
	installStep1: `${IMG}/install-step-1.png`,
	installStep2: `${IMG}/install-step-2.png`,
	installStep3: `${IMG}/install-step-3.png`,
	featureOverview: `${IMG}/feature-overview.png`,
	whatIsBanner: `${IMG}/what-is-gb-whatsapp.png`,
};

/** Key Features 六宫格卡片（图内含标题与描述） */
export const FEATURE_CARD_IMAGES = {
	privacy: `${IMG}/feature-card-privacy.png`,
	themes: `${IMG}/feature-card-themes.png`,
	media: `${IMG}/feature-card-media.png`,
	status: `${IMG}/feature-card-status.png`,
	dnd: `${IMG}/feature-card-dnd.png`,
	dual: `${IMG}/feature-card-dual.png`,
};

export const DOWNLOAD_SHOWCASE = {
	image: HOME_IMAGES.siteLogo,
	imageAlt: 'GB WhatsApp APK download for Android — latest version 18.80',
	title: 'Download GB WhatsApp APK Latest Version',
	bullets: [
		'Version 18.80 · about 82 MB',
		'Android 4.4 or newer',
		'Anti-ban focused mod build for 2026',
		'Match file size on GBWaps before you install',
	],
	ctaText: 'Download GB WhatsApp APK',
	ctaTo: '/download/',
};

export const INSTALL_STEPS = [
	{
		step: 1,
		title: 'Get the APK file',
		text: 'Tap Download GB WhatsApp APK on our download hub and wait until the full file lands in Downloads.',
		image: HOME_IMAGES.installStep1,
		alt: 'Download GB WhatsApp APK file on Android',
	},
	{
		step: 2,
		title: 'Allow unknown apps',
		text: 'Open Settings → Install unknown apps → enable your browser or Files app, then open the APK.',
		image: HOME_IMAGES.installStep2,
		alt: 'Enable install unknown apps for GB WhatsApp APK',
	},
	{
		step: 3,
		title: 'Verify & restore chats',
		text: 'Enter your number, confirm SMS, and restore backup if you are moving from official WhatsApp.',
		image: HOME_IMAGES.installStep3,
		alt: 'Verify phone number in GB WhatsApp app after install',
	},
];

export const VERIFY_BLOCKS = [
	{
		title: 'Install check',
		icon: '✓',
		items: ['APK opens without parse error', 'About screen shows v18.80', 'Login completes on Wi‑Fi'],
	},
	{
		title: 'Safety habits',
		icon: '🛡',
		items: ['Download only from gbwaps.com', 'Skip pop-up mirror sites', 'Scan file if size looks wrong'],
	},
	{
		title: 'Daily use',
		icon: '⚡',
		items: ['Chats send after setup', 'Themes load without freeze', 'Update when app says outdated'],
	},
];

/** 下载要求四卡（图文） */
export const DOWNLOAD_REQUIREMENT_CARDS = [
	{
		icon: '🤖',
		image: HOME_IMAGES.installStep1,
		imageAlt: 'Android system requirements for GB WhatsApp APK',
		title: 'System & storage',
		items: ['Android 4.4 (KitKat) or newer', '~200 MB free space for APK + cache'],
	},
	{
		icon: '📱',
		image: HOME_IMAGES.featureOverview,
		imageAlt: 'GB WhatsApp compatible Android phones',
		title: 'Device compatibility',
		items: [
			'ARM build: Samsung, Xiaomi, Oppo, Motorola, etc.',
			'x86 tablets need a dedicated x86 APK if available',
		],
	},
	{
		icon: '⚙️',
		image: HOME_IMAGES.installStep2,
		imageAlt: 'Enable unknown sources for GB WhatsApp install',
		title: 'Network & permissions',
		items: [
			'Stable Wi‑Fi for ~82 MB download',
			'SMS for verification; allow unknown app install',
		],
	},
	{
		icon: '📲',
		image: HOME_IMAGES.installStep3,
		imageAlt: 'GB WhatsApp on older Android devices',
		title: 'Older devices',
		items: ['2 GB RAM recommended for themes & media', 'Lighter build available for old phones'],
		link: { to: '/old-version/', text: 'GB WhatsApp Old Version' },
	},
];

export const HOME_TOC = [
	{ id: 'what-is-gb-whatsapp', label: 'What is GB WhatsApp' },
	{ id: 'latest-version-2026', label: 'Latest version 2026' },
	{ id: 'why-people-use', label: 'Why people use it' },
	{ id: 'key-features', label: 'Key features' },
	{ id: 'privacy-security', label: 'Privacy & security' },
	{ id: 'how-to-download', label: 'How to download' },
	{ id: 'download-requirements', label: 'Requirements' },
	{ id: 'how-to-install', label: 'How to install' },
	{ id: 'how-to-update', label: 'How to update' },
	{ id: 'is-it-safe', label: 'Is it safe?' },
	{ id: 'anti-ban', label: 'Anti-ban' },
	{ id: 'common-issues', label: 'Common issues' },
	{ id: 'comparison', label: 'vs official WhatsApp' },
	{ id: 'faq-section', label: 'FAQ' },
	{ id: 'final-summary', label: 'Final summary' },
];
